import LogicaAPI from "./logicaapi";

class Order extends LogicaAPI {
  // courseは/orders
  // productはproduct_ordersで取得
  // コース名はIDで別途紐付け
  // 表示はまとめていい感じにする
  async getCourseOrders(args) {
    const params = {
      with_subscription_order: true,
      with_payment_instrument: true,
      course_only: true,
    };
    const res = this.get("/api/v1/orders", { params });
    return res;
  }

  async getOrderOne(orderId) {
    const res = this.get(`/api/v1/orders/${orderId}`);
    return res;
  }

  async getProductOrders(args) {
    const params = {
      with_order: args.with_order,
      with_payment_instrument: args.with_payment_instrument,
      with_entitlements: args.with_entitlements,
    };
    return this.get("/api/v1/product_orders", { params });
  }

  async getCourseList(args) {
    return this.get("/api/v1/courses");
  }
}
export default Order;
